import { captureException } from '@sentry/react'
import { z } from 'zod'

class SchematizeError {
  readonly type = 'schema'
  readonly error: z.ZodIssue[]

  constructor(error: z.ZodIssue[]) {
    this.error = error
  }
}

function schematize<T>(data: unknown, schema: z.ZodType<T>) {
  const parsed = schema.safeParse(data)

  if (!parsed.success) {
    const { error } = parsed
    console.error(error)

    const schemaError = new SchematizeError(error.errors)
    captureException(schemaError)

    throw new SchematizeError(error.errors)
  }

  return parsed.data
}

export { schematize, SchematizeError }
